import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface IAuthShellProps {
  aside?: ReactNode;
  children: ReactNode;
  className?: string;
}

interface IAuthAlertProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function AuthShell({ aside, children, className }: IAuthShellProps) {
  return (
    <div className={cn('auth-shell', className)}>
      <div className="auth-main">
        <div className="auth-card">{children}</div>
      </div>
      {aside ?? null}
    </div>
  );
}

export function AuthAlert({ children, className, ...props }: IAuthAlertProps) {
  return (
    <div className={cn('auth-alert-danger', className)} role="alert" {...props}>
      {children}
    </div>
  );
}
